module.exports = __webpack_public_path__ + "static/media/clock.dc169d0a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/vectors/clock.svg
// module id = 552
// module chunks = 0